import { useState } from "react";
import { Quote, ChevronLeft, ChevronRight, Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const total = TESTIMONIALS.length;
  const t = TESTIMONIALS[i];

  const prev = () => setI((p) => (p - 1 + total) % total);
  const next = () => setI((p) => (p + 1) % total);

  return (
    <section data-testid="testimonials-section" className="py-20 sm:py-24 lg:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl reveal">
          <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-primary">Testimonials</p>
          <h2 className="mt-3 font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-slate-900 leading-tight tracking-tight">
            What our clients say
          </h2>
        </div>

        <div className="mt-14 grid lg:grid-cols-12 gap-8 lg:gap-12 items-stretch">
          <div className="lg:col-span-8 bg-white border border-slate-200 rounded-3xl p-8 sm:p-12 shadow-sm relative overflow-hidden">
            <Quote className="absolute top-6 right-6 w-16 h-16 text-primary/10" strokeWidth={1.25} />
            <div className="flex items-center gap-1 text-amber-500">
              {[0, 1, 2, 3, 4].map((s) => <Star key={s} className="w-4 h-4 fill-current" />)}
            </div>
            <blockquote className="mt-6 font-heading text-xl sm:text-2xl lg:text-3xl text-slate-900 leading-snug tracking-tight">
              "{t.quote}"
            </blockquote>
            <div className="mt-8 flex items-center justify-between">
              <div>
                <div className="font-heading font-bold text-slate-900">{t.name}</div>
                <div className="text-sm text-slate-500">{t.role} · {t.company}</div>
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={prev}
                  data-testid="testimonial-prev"
                  className="w-10 h-10 rounded-full border border-slate-200 hover:bg-primary hover:text-white hover:border-primary text-slate-700 flex items-center justify-center transition-colors"
                  aria-label="Previous testimonial"
                >
                  <ChevronLeft className="w-4 h-4" />
                </button>
                <button
                  onClick={next}
                  data-testid="testimonial-next"
                  className="w-10 h-10 rounded-full border border-slate-200 hover:bg-primary hover:text-white hover:border-primary text-slate-700 flex items-center justify-center transition-colors"
                  aria-label="Next testimonial"
                >
                  <ChevronRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>

          <div className="lg:col-span-4 grid grid-cols-1 gap-4 content-start">
            {TESTIMONIALS.slice(0, 3).map((te, idx) => (
              <button
                key={te.name}
                onClick={() => setI(idx)}
                data-testid={`testimonial-thumb-${idx}`}
                className={`text-left bg-white border rounded-2xl p-5 transition-all duration-200 ${
                  i === idx ? "border-primary shadow-md" : "border-slate-200 hover:border-slate-300"
                }`}
              >
                <div className="font-heading font-bold text-slate-900 text-sm">{te.name}</div>
                <div className="text-xs text-slate-500 mt-0.5">{te.company}</div>
                <p className="mt-2 text-xs text-slate-600 leading-relaxed line-clamp-2">"{te.quote}"</p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
